<template>
  <div class="video-list">
    <div class="video-item" v-for="(item, index) in data" :key="index">
      <div class="video-item-title">{{ item.title }}</div>
      <div class="video-item-content">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="getPlayerOptions(item)"
          @play="handlePlay(index)"
        ></video-player>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      videoList: [
        {
          // title: '韶关浈江油茶产业园--精准扶贫专题片'
          title: "精准扶贫专题片",
          // content: 'https://admin.gdyfpt.com/file/vedio/fupin.mp4'
          content: "http://www.shkjem.com/video/kj.mp4",
        },
      ],
      videoSrc: "http://www.shkjem.com/video/kj.mp4",
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0, 4.0, 8.0], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        // sources: [
        //   {
        //     type: "",
        //     src: "http://www.shkjem.com/video/kj.mp4" //url地址
        //   }
        // ],
        //poster: "../../assets/img/home_top.jpg", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  methods: {
    handlePlay(index) {
      var comps = this.$refs.videoPlayer;
      if (!(comps instanceof Array)) {
        comps = [comps];
      }
      for (let x in comps) {
        if (x == index) continue;
        comps[x].player.pause();
      }
    },
    getPlayerOptions(item) {
      console.log("video", item.content);
      return {
        ...this.playerOptions,
        sources: [
          {
            type: "",
            src: item.content,
          },
        ],
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/color.scss";
.video-list {
  .video-item {
    margin-bottom: 80px;
    .video-item-title {
      height: 42px;
      line-height: 42px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: $primary-color;
      margin-bottom: 12px;
    }
    .video-item-content {
      width: 100%;
      height: 624px;
    }
  }
}
</style>
